





































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import mapStore, {
    Category,
    UpEventVo,
    CategoryVo
} from '../../../../store/nexus';
interface TipsVo {
    title: string;
    total: number;
}
@Component({
    components: {}
})
export default class TypeLink extends Vue {
    box!: HTMLElement;
    curIndex: number = 0;
    tips!: HTMLDivElement;
    trigger: string = 'TypeLink';
    tipsList: Array<TipsVo> = [];
    typeList: Array<CategoryVo> = [];
    dataSource = mapStore.dataSource;
    onUpList(ev: UpEventVo) {
        const category: Category = this.dataSource.category;
        this.typeList = [];
        for (let [key, vo] of Object.entries(category)) {
            if (vo.total) {
                if (ev.trigger !== this.trigger) {
                    if (vo.categoryNum > 0) {
                        this.typeList.push(vo);
                    }
                } else {
                    this.typeList.push(vo);
                }
            }
        }
        this.upTips(this.typeList[this.curIndex]);
    }
    countStyle(index: number) {
        const category: CategoryVo | null = this.isTips(this.typeList[index]);
        if (category) {
            return `background: ${category.color};`;
        }
        return `background: #E1E5EA;`;
    }
    itemHidden(el: HTMLLIElement) {
        el.style.cssText = 'font-family: PingFangSC-Medium;color: #333333;';
    }
    itemClick(index: number, ev: MouseEvent) {
        let el: HTMLElement = ev.target as HTMLElement;
        const data: CategoryVo = this.typeList[index];
        const isDisplay: boolean = (data.isDisplay = !data.isDisplay);
        if (el.tagName.toLocaleUpperCase() !== 'I') {
            el = el.querySelector('i') as HTMLElement;
        }
        el.style.cssText = this.countStyle(index);
        mapStore.displayCategory(data.vertexClassMid, isDisplay, this.trigger);
        if (isDisplay) {
            this.itemEnter(index, ev);
        } else {
            this.itemLeave(ev);
        }
    }
    upTips(vo: CategoryVo) {
        this.tipsList = vo
            ? [{ title: vo.vertexClassDisplayName, total: vo.categoryNum }]
            : [];
    }
    isTips(category: CategoryVo): CategoryVo | null {
        if (category.isDisplay && category.categoryNum > 0) {
            return category;
        }
        return null;
    }
    itemEnter(index: number, ev: MouseEvent) {
        const category: CategoryVo | null = this.isTips(this.typeList[index]);
        if (category) {
            this.curIndex = index;
            this.upTips(category);
            this.itemHidden(ev.target as HTMLLIElement);
            this.tips.style.display = 'block';
            const { height } = this.tips.getBoundingClientRect();
            const { width } = this.box.getBoundingClientRect();
            const top = -height / 2 + index * 32;
            this.tips.style.transform = `translate(${width + 10}px, ${top}px)`;
        }
    }
    itemLeave(ev: MouseEvent) {
        const el: HTMLLIElement = ev.target as HTMLLIElement;
        this.tips.style.display = 'none';
        el.style.cssText = '';
    }
    mounted() {
        this.box = this.$refs.box as HTMLElement;
        this.tips = this.$refs.tips as HTMLDivElement;
        mapStore.on(mapStore.EVENT_UP_TYPE, this.onUpList.bind(this));
    }
}
